import { DateHelper } from './DateHelper';
export class SafeDateOnly {
    private internalDate?: Date | undefined;

    get dateValue(): Date | undefined {
        return this.internalDate;
    }

    set dateValue(date: Date | undefined) {
        this.internalDate = date;
    }

    get isSet(): boolean {
        return this.internalDate !== null && this.internalDate !== undefined;
    }

    private static adjustUtcDateToLocalDateOfSameDay(utcString: string): Date | undefined {
        if (!utcString || utcString.length === 0) {
            return undefined;
        }
        const dateObj = DateHelper.getDateObjectFrom(utcString);
        const offset = dateObj.getTimezoneOffset();
        return (new Date(dateObj.getTime() + (60 * 1000 * offset)));
    }

    static fromUtcDateString(utcDateString: string) {
        const safeDate = new SafeDateOnly();
        if (utcDateString && utcDateString.indexOf('0001-01-01T') === -1) {
            safeDate.internalDate = this.adjustUtcDateToLocalDateOfSameDay(utcDateString);
        }
        return safeDate;
    }

    static fromLocalDate(date: Date) {
        const safeDate = new SafeDateOnly();
        safeDate.internalDate = date;
        return safeDate;
    }

    toDateOnlyString(): string | undefined {
        if (this.internalDate) {
            return `${DateHelper.dateToInternationalString(this.internalDate)}T00:00:00.000Z`;
        }
        return undefined;
    }

}